// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"ProgramDetailsFooter_actionButton__OL_Ls","updateButton":"ProgramDetailsFooter_updateButton__3J36n"};